document.addEventListener("DOMContentLoaded", function() {
    const banner = document.getElementById('cookie-banner');
    const cookieName = 'user_cookie_consent';
    
    // Функция для получения cookie
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    // Функция для установки cookie (срок действия 1 год)
    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    // Функция запуска аналитики и маркетинговых скриптов
    function loadMarketingScripts() {
        console.log('Загрузка маркетинговых скриптов (Analytics, Pixel и т.д.)...');
        
        // ПРИМЕР: Google Analytics (вставьте свой код сюда)
        /*
        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');
        ga('create', 'UA-XXXXX-Y', 'auto');
        ga('send', 'pageview');
        */
    }

    // Проверяем текущий статус
    const consent = getCookie(cookieName);

    if (!consent) {
        // Если выбора не было, показываем баннер
        banner.style.display = 'block';
    } else if (consent === 'all') {
        // Если ранее приняли всё, грузим скрипты
        loadMarketingScripts();
    }

    // Обработчики кнопок

    // 1. Принять все
    document.getElementById('btn-accept-all').addEventListener('click', function() {
        setCookie(cookieName, 'all', 365);
        banner.style.display = 'none';
        loadMarketingScripts(); // Сразу запускаем скрипты
    });

    // 2. Только необходимые
    document.getElementById('btn-necessary').addEventListener('click', function() {
        setCookie(cookieName, 'necessary', 365);
        banner.style.display = 'none';
        // Маркетинговые скрипты НЕ запускаем
        console.log('Только необходимые cookies. Аналитика отключена.');
    });

    // 3. Отказаться (по сути то же, что и необходимые, но семантически отказ)
    document.getElementById('btn-reject').addEventListener('click', function() {
        setCookie(cookieName, 'rejected', 365);
        banner.style.display = 'none';
        // Маркетинговые скрипты НЕ запускаем
        console.log('Пользователь отказался от cookies.');
    });
});